var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg003CBulletUndDomeKamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.6669999999999,
    height: 451.6669999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 453.667,
    height: 453.667,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#e3e8ee",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 621.436082,
    cy: 207.208153,
    id: "svg_23",
    rx: 0.325867
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 224.459066,
    cy: 225.79493,
    id: "svg_5",
    rx: 213.74094,
    ry: 213.823302
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    x: 54.346327,
    y: 61.97062,
    width: 211.0792,
    height: 23.283465,
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    x: 54.346328,
    y: 61.970622,
    width: 56.930078,
    height: 59.746248,
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    x: 208.057535,
    y: 62.409933,
    width: 56.930078,
    height: 59.746248,
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 115.217714,
    cy: 90.525813,
    id: "svg_17",
    rx: 14.013557,
    ry: 11.422077
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 206.08688,
    cy: 89.647192,
    id: "svg_18",
    rx: 18.611757,
    ry: 12.740009
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 112.714966,
    cy: 195.7191,
    id: "svg_19",
    rx: 32.877359,
    ry: 68.101015,
    transform: "matrix(0.6138441671949236,-0.2741666418961325,0.2733010315445091,0.6157883598765419,-39.459034807744764,42.36538423497089) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 338.866694,
    cy: 197.674303,
    id: "svg_20",
    rx: 32.877359,
    ry: 68.101015,
    transform: "matrix(-0.6314133898865136,-0.23054356117837488,0.22981567943581147,-0.6334132285382399,403.7164479840934,336.6352312180411) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#ff0033",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 159.448003,
    cy: 134.017569,
    id: "svg_21",
    rx: 32.844274,
    ry: 32.9483
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 160.32385,
    cy: 135.994466,
    id: "svg_22",
    rx: 7.444702,
    ry: 9.005869
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#193351",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 32.01222,
    y: 4.860234,
    width: 257.061189,
    height: 51.399347,
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m180.68948,32.43366c-2.94422,0 -5.33374,2.40866 -5.33374,5.37647s2.38952,5.37647 5.33374,5.37647c2.94423,0 5.33375,-2.40866 5.33375,-5.37647s-2.38952,-5.37647 -5.33375,-5.37647z",
    id: "svg_1",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m290.56459,0.17486l-262.42016,0c-2.94582,0 -5.33374,2.40758 -5.33374,5.37646l0,32.25881c0,14.09871 10.82483,25.68822 24.53522,26.78879l0,26.97588c0,41.68805 22.44812,78.2319 55.9995,97.7958c0.04161,0.02419 0.08374,0.04784 0.12587,0.07204c0.00161,0.00107 0.00321,0.00215 0.00481,0.00269c16.91543,9.8357 36.23371,15.03529 55.87842,15.03529c20.33063,0 39.73585,-5.58293 56.0091,-15.11002l-0.00053,0.00053c16.71862,-9.74861 30.74049,-23.76721 40.54978,-40.54071c10.10745,-17.2848 15.45026,-37.08311 15.45026,-57.25562l0,-26.97588c13.71038,-1.10003 24.53521,-12.69008 24.53521,-26.78879l0,-32.2588c0,-2.96888 -2.38792,-5.37647 -5.33374,-5.37647zm-83.20639,181.38265c-14.67633,7.96846 -31.20507,12.17017 -48.00369,12.17017c-16.79809,0 -33.32682,-4.20171 -48.00369,-12.17017l0,-46.97097c0,-26.68126 21.53446,-48.3882 48.00369,-48.3882c26.46923,0 48.00369,21.70694 48.00369,48.3882l0,46.97097zm53.33743,-89.98271c0,33.14055 -16.13991,64.23965 -42.66995,83.28793l0,-40.27619c0,-32.61042 -26.31988,-59.14114 -58.67117,-59.14114s-58.67117,26.53072 -58.67117,59.14114l0,40.27619c-26.53004,-19.04828 -42.66994,-50.14738 -42.66994,-83.28793l0,-26.88234l202.68223,0l0,26.88234zm24.53521,-59.14114l-83.20639,0c-2.94582,0 -5.33374,2.40758 -5.33374,5.37647c0,2.96889 2.38792,5.3227 5.33374,5.3227l82.28899,0c-2.20177,6.25767 -8.13075,10.8067 -15.08382,10.8067c-19.5023,0 -192.76147,0 -219.75022,0c-8.82308,0 -16.00122,-7.23565 -16.00122,-16.1294l0,-26.88234l251.75266,0l0,21.50587z",
    id: "svg_2",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m159.35451,96.95127c-20.58718,0 -37.3362,16.88318 -37.3362,37.63527c0,20.75209 16.74902,37.63527 37.3362,37.63527c20.58719,0 37.3362,-16.88318 37.3362,-37.63527c0,-20.75209 -16.74901,-37.63527 -37.3362,-37.63527zm0,64.51761c-14.70513,0 -26.66872,-12.05942 -26.66872,-26.88234s11.96359,-26.88234 26.66872,-26.88234s26.66872,12.05942 26.66872,26.88234s-11.96359,26.88234 -26.66872,26.88234z",
    id: "svg_3",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m159.35451,118.45714c-8.82307,0 -16.00123,7.23565 -16.00123,16.1294s7.17816,16.12941 16.00123,16.12941s16.00123,-7.23566 16.00123,-16.12941s-7.17815,-16.1294 -16.00123,-16.1294zm0,21.50587c-2.94103,0 -5.33374,-2.41189 -5.33374,-5.37647c0,-2.96458 2.39271,-5.37646 5.33374,-5.37646c2.94103,0 5.33375,2.41188 5.33375,5.37646c0,2.96459 -2.39272,5.37647 -5.33375,5.37647z",
    id: "svg_4",
    fill: "#193351"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "null",
    fill: "none",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    points: "106.89716843387362,185.85622474897343 106.89716843387362,185.85622474897343 106.89716843387362,185.85622474897343 ",
    id: "svg_9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "null",
    fill: "none",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    points: "143.68274753665958,197.71762080237556 144.5586041787334,197.71762080237556 ",
    id: "svg_10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "null",
    fill: "none",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    points: "217.6918494426651,183.22036353061947 217.6918494426651,183.22036353061947 217.6918494426651,183.22036353061947 ",
    id: "svg_11",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 12.295673,
    rx: 11.495409,
    id: "svg_6",
    cy: 341.092536,
    cx: 334.294464,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_8",
    d: "m296.00143,260.72958c-1.7588,-3.06054 -5.6562,-4.11122 -8.70415,-2.34387l-0.14146,0.0819c-3.04795,1.76606 -4.09367,5.67955 -2.33423,8.74009c1.18018,2.05337 3.3226,3.2013 5.52556,3.2013c1.08013,0 2.17556,-0.27642 3.17858,-0.85743l0.14147,-0.08191c3.04795,-1.76605 4.09367,-5.67954 2.33423,-8.74008z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_12",
    d: "m339.2341,235.66111c-1.75943,-3.05989 -5.65492,-4.10929 -8.70477,-2.34195l-26.28321,15.2374c-3.04795,1.76669 -4.0924,5.68018 -2.33233,8.74072c1.18082,2.05209 3.32197,3.20002 5.52492,3.20002c1.08078,0 2.1762,-0.27642 3.17986,-0.85807l26.28321,-15.23739c3.04795,-1.76671 4.09239,-5.6802 2.33232,-8.74073z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_13",
    d: "m351.40868,256.83465c-1.7588,-3.06118 -5.65555,-4.11122 -8.70414,-2.34387l-0.14147,0.0819c-3.04795,1.76606 -4.09366,5.67955 -2.33423,8.74009c1.18018,2.054 3.3226,3.2013 5.52556,3.2013c1.08013,0 2.17556,-0.27643 3.17859,-0.85743l0.14146,-0.08191c3.04794,-1.76606 4.09367,-5.67955 2.33423,-8.74008z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_24",
    d: "m311.35977,281.09767c-1.50627,-2.78687 -4.9284,-3.79467 -7.64581,-2.24927l-23.42738,13.32398c-2.71739,1.54484 -3.69855,5.0565 -2.19228,7.84396c1.01053,1.87015 2.88244,2.93849 4.8265,2.97331c0.95375,0.01708 1.92523,-0.21485 2.81929,-0.72346l23.42738,-13.32399c2.71684,-1.54542 3.69857,-5.05707 2.1923,-7.84453z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 21.152779,
    rx: 20.408852,
    id: "svg_25",
    cy: 352.68441,
    cx: 350.270514,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.6504334580004129,0.011621927784117261,-0.01135335824088229,0.6658197968275348,-70.75568064815741,112.92993221368158) ",
    id: "svg_26",
    height: 36.112312,
    width: 84.925351,
    y: 322.5702,
    x: 683.461518,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.5633777032527028,-0.3329606099273902,0.325266268628381,0.5767046933133623,-144.35264971185404,224.57993324503283) ",
    id: "svg_27",
    height: 100.232101,
    width: 297.956273,
    y: 370.954603,
    x: 357.410596,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.5689685772201574,-0.3228450137117736,0.315384432345337,0.5824278222872972,-117.27738829426664,218.30435260790506) ",
    id: "svg_28",
    height: 141.745992,
    width: 270.721591,
    y: 266.547025,
    x: 387.442894,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.5689685772201574,-0.3228450137117736,0.315384432345337,0.5824278222872972,-135.95992735887558,174.03738160711447) ",
    id: "svg_29",
    height: 42.192041,
    width: 199.426291,
    y: 339.705654,
    x: 279.604525,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-0.636316840516977,-0.13845280677143224,0.1352533197530204,-0.6513692434786827,48.385057712051264,488.24044275133366) ",
    id: "svg_30",
    height: 70.051135,
    width: 148.20726,
    y: 302.50001,
    x: -238.717681,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 12.796128,
    rx: 11.73509,
    id: "svg_31",
    cy: 318.056626,
    cx: 331.90266,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ff0033",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 191.356435,
    y: 339.74706,
    width: 40.474356,
    height: 18.309828,
    id: "svg_40",
    transform: "matrix(-0.5473076417643085,-1.0088453413331024,1.029335966552425,-0.5364125830745541,-71.46977017828067,740.863821356781) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_32",
    d: "m444.73918,289.65028l-9.71245,0c-8.94222,0 -16.21713,7.447 -16.21713,16.60074l0,24.30346l-43.60389,0c-4.8829,-6.54466 -12.20789,-11.07626 -20.57049,-12.16504l-9.14519,-16.21453l37.63526,-22.24243c3.1115,-1.8386 4.17772,-5.91138 2.38095,-9.09648l-8.88627,-15.75636l15.39225,-9.09715c3.1115,-1.83862 4.17772,-5.91138 2.38095,-9.09648l-36.41877,-64.57239c-5.47422,-9.70514 -15.71751,-15.73439 -26.73298,-15.73439c-5.37145,0 -10.66873,1.45304 -15.31939,4.2013l-194.49752,114.94932c-3.1115,1.83861 -4.17772,5.91139 -2.38094,9.09649l12.13894,21.52324c0.8626,1.52961 2.28336,2.6457 3.95002,3.10252l17.99894,4.93715l-7.42777,4.38908c-1.49428,0.88301 -2.58458,2.33739 -3.03085,4.04347c-0.44691,1.70609 -0.21272,3.52406 0.64988,5.05301l24.27789,43.04449c1.20543,2.13628 3.39122,3.33093 5.64011,3.33093c1.1033,0 2.22222,-0.28768 3.24616,-0.893l15.39419,-9.09847l8.88758,15.75836c0.86261,1.52961 2.28336,2.6457 3.95003,3.10252c0.55426,0.15184 1.11957,0.22708 1.68359,0.22708c1.13191,0 2.25539,-0.30299 3.25266,-0.89233l103.54005,-61.1935l9.14194,16.20785c-1.5385,3.74648 -2.39071,7.85787 -2.39071,12.17038c0,17.37656 13.81016,31.51272 30.78451,31.51272c9.9707,0 18.84462,-4.8812 24.47433,-12.42741l43.60389,0l0,24.30345c0,9.15309 7.2749,16.60009 16.21713,16.60009l9.71245,0c3.59289,0 6.50533,-2.98133 6.50533,-6.65921l0,-106.65928c0.00065,-3.67787 -2.91244,-6.65921 -6.50467,-6.65921l-0.00001,0.00001zm-303.63671,7.65143l-7.53903,-13.3677l188.86391,-111.61972c2.67499,-1.5809 5.72339,-2.41663 8.81407,-2.41663c6.38172,0 12.30808,3.47744 15.46511,9.07518l33.1661,58.80551l-144.47678,85.38641l-94.29339,-25.86304l0,-0.00001l0.00001,0zm34.51336,61.19151l-17.77256,-31.51007l9.76125,-5.76888l17.77189,31.51006l-9.76058,5.76889zm33.16805,9.09781l-25.31093,-44.8791c-0.00064,-0.00066 0,0 -0.00064,-0.00066l51.15982,14.03229c0.24981,0.06859 0.50156,0.11587 0.75462,0.15316c0.07546,0.01132 0.15092,0.01798 0.22704,0.02664c0.1867,0.02065 0.37275,0.03329 0.56011,0.03728c0.04684,0.00068 0.09433,0.00934 0.14181,0.00934c0.02928,0 0.0579,-0.00534 0.08717,-0.006c0.24981,-0.00334 0.49831,-0.01731 0.74551,-0.04995c0.0052,-0.00067 0.0104,-0.00067 0.01496,-0.00133c0.25175,-0.03396 0.50092,-0.08724 0.74681,-0.15183c0.07221,-0.01865 0.14378,-0.04129 0.21533,-0.0626c0.18216,-0.05393 0.3617,-0.11586 0.53865,-0.18646c0.07025,-0.02796 0.14115,-0.05393 0.21012,-0.08456c0.23613,-0.10389 0.46903,-0.2171 0.69346,-0.34962l125.78437,-74.34012l5.63361,9.98949l-162.20184,95.86403l0.00002,0zm115.67964,-52.98869l9.75929,-5.76821l6.25813,11.09558c-3.60591,1.30787 -6.90151,3.28499 -9.75019,5.78352l-6.26723,-11.11089zm44.00528,36.14621c-0.00521,0.08723 -0.01302,0.17381 -0.01887,0.26037c-0.02147,0.28834 -0.04879,0.57669 -0.08327,0.86304c-0.01106,0.08989 -0.02147,0.1798 -0.03383,0.26902c-0.04359,0.32498 -0.09497,0.64862 -0.15613,0.97026c-0.00716,0.03662 -0.01236,0.07325 -0.01887,0.10987c-0.06959,0.35827 -0.15157,0.7132 -0.24264,1.06613c-0.02212,0.08791 -0.04879,0.17515 -0.07221,0.26305c-0.06831,0.24773 -0.14117,0.49478 -0.21923,0.73984c-0.04228,0.13451 -0.08717,0.26836 -0.1327,0.40155c-0.06636,0.19244 -0.13726,0.38157 -0.20947,0.57136c-0.05856,0.15117 -0.1132,0.30366 -0.17435,0.45216c-0.02342,0.05794 -0.0514,0.11387 -0.07546,0.17115c-0.17954,0.42152 -0.37406,0.83438 -0.58289,1.23861c-0.04813,0.09323 -0.09627,0.18646 -0.14636,0.27902c-3.03018,5.61638 -8.87326,9.43011 -15.57114,9.43011c-9.80028,0 -17.77385,-8.1622 -17.77385,-18.1943s7.97357,-18.1943 17.77385,-18.1943c6.69657,0 12.53836,3.8124 15.56854,9.42679c0.05139,0.09522 0.10083,0.19177 0.15027,0.28834c0.10213,0.19777 0.20427,0.39555 0.29925,0.59732c0.1249,0.26704 0.2459,0.53607 0.35779,0.8091c0.06115,0.14651 0.11515,0.29633 0.17175,0.44484c0.0735,0.19244 0.14636,0.3849 0.21272,0.57935c0.04488,0.13185 0.08912,0.26437 0.13141,0.39755c0.0787,0.24706 0.15222,0.49545 0.22052,0.74583c0.02342,0.0859 0.04944,0.17114 0.07157,0.25771c0.09107,0.35361 0.17304,0.70921 0.24265,1.06814c0.00714,0.0353 0.01235,0.07125 0.01886,0.10655c0.06115,0.32231 0.11255,0.64727 0.15612,0.97291c0.01236,0.08856 0.02277,0.17846 0.03383,0.2677c0.03449,0.28702 0.0618,0.5747 0.08326,0.8637c0.00652,0.08658 0.01368,0.17248 0.01888,0.25971c0.02211,0.36892 0.03578,0.73784 0.03578,1.10876s-0.01367,0.73984 -0.03578,1.10876zm50.3408,4.65879l-37.81351,0l0,-0.00067c0.02213,-0.12453 0.03839,-0.24973 0.0592,-0.37425c0.0501,-0.29701 0.09954,-0.59401 0.14182,-0.89368c0.02928,-0.20709 0.0527,-0.41486 0.07742,-0.62197c0.03448,-0.28633 0.07025,-0.57268 0.09693,-0.86169c0.02342,-0.25039 0.03903,-0.5021 0.05594,-0.75382c0.01756,-0.24905 0.03969,-0.49611 0.05074,-0.7465c0.01887,-0.41087 0.02667,-0.82241 0.03058,-1.23462c0.00065,-0.09389 0.00716,-0.18646 0.00716,-0.28102c0,-0.09456 -0.00651,-0.18712 -0.00716,-0.28102c-0.00391,-0.4122 -0.01107,-0.82374 -0.03058,-1.23461c-0.01171,-0.25039 -0.03318,-0.49812 -0.05074,-0.74717c-0.01757,-0.25104 -0.03252,-0.50211 -0.05594,-0.75249c-0.02668,-0.28967 -0.06311,-0.57602 -0.09693,-0.86303c-0.02538,-0.20643 -0.04814,-0.41354 -0.07742,-0.61931c-0.04163,-0.301 -0.09172,-0.59933 -0.14182,-0.897c-0.02081,-0.12386 -0.03708,-0.24839 -0.0592,-0.37158l37.81351,0l0,11.53443zm19.42426,40.90286l-3.20713,0c-1.73822,0 -3.20648,-1.5023 -3.20648,-3.28166l0,-86.77819c0,-1.77934 1.46825,-3.28232 3.20648,-3.28232l3.20713,0l0,93.34217z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_33",
    d: "m292.81122,234.42276c-1.79548,-3.18509 -5.77414,-4.27855 -8.88564,-2.43927l-0.1444,0.08524c-3.11151,1.83795 -4.17903,5.91072 -2.38291,9.09582c1.20478,2.13694 3.39188,3.33161 5.64077,3.33161c1.10265,0 2.22092,-0.28768 3.24485,-0.89234l0.14442,-0.08524c3.11149,-1.83794 4.17902,-5.91072 2.38291,-9.09582z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_34",
    d: "m336.94529,208.33397c-1.79613,-3.18444 -5.77283,-4.27655 -8.88627,-2.43727l-26.83122,15.85758c-3.11149,1.83861 -4.17772,5.91137 -2.38095,9.09649c1.20545,2.13561 3.39123,3.33026 5.64012,3.33026c1.10331,0 2.22157,-0.28768 3.24615,-0.893l26.83122,-15.85758c3.1115,-1.8386 4.17772,-5.91138 2.38095,-9.09648z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_35",
    d: "m349.37372,230.3693c-1.79547,-3.18576 -5.77348,-4.27854 -8.88562,-2.43926l-0.14442,0.08523c-3.11151,1.83794 -4.17903,5.91071 -2.38291,9.09582c1.20479,2.13761 3.39188,3.3316 5.64077,3.3316c1.10265,0 2.22092,-0.28767 3.24485,-0.89233l0.14442,-0.08523c3.11151,-1.83796 4.17902,-5.91073 2.38291,-9.09583z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_36",
    d: "m331.92252,240.67909c-1.79677,-3.18444 -5.77411,-4.27655 -8.88626,-2.43726l-26.83057,15.85757c-3.11215,1.83861 -4.17773,5.91071 -2.38095,9.09582c1.20544,2.13694 3.39122,3.33094 5.64011,3.33094c1.10331,0 2.22223,-0.28767 3.24616,-0.893l26.83056,-15.85758c3.11151,-1.83927 4.17772,-5.91139 2.38095,-9.09649z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.6504334580004129,0.011621927784117261,-0.01135335824088229,0.6658197968275348,-70.71707157238859,112.26068562127665) ",
    id: "svg_37",
    height: 146.601513,
    width: 16.208271,
    y: 270.223539,
    x: 775.430187,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#193351",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003CBulletUndDomeKamera);
export default __webpack_public_path__ + "static/media/003c-Bullet-und-Dome-Kamera.9f40ea2f719c57510be0a4c4b84441bf.svg";
export { ForwardRef as ReactComponent };